// External libraries
import React, { Fragment } from 'react';
import { useStoreState } from '@/store';

// Internal modules
import { useMountLogging } from '@/lib/reactHooks';
import { CardCvv } from '../CardCvv';
import { CardExpiry } from '../CardExpiry';
import { CreditCardAndBankIconsBar } from '../CardIconsBar';
import { CardNumber } from '../CardNumber';
import { CardTypeSelector } from '../CardTypeSelector';
import { DateOfBirth } from '../DateOfBirth';
import { CardDetailsContainer } from './StyledComponents';
import { CurrencyConversion } from '../CurrencyConversion';
import { InstallmentButton } from '../InstallmentButton';
import { CardProductClassRadioButtons } from '../CardProducClassRadioButtons';
import { features } from '@/lib';

const CardVendors = () => {
  const hasCardTypeSelector = useStoreState(({ ui }) => ui.hasCardTypeSelector);
  const shouldCollectCardProductClass = features.isActive(
    'shouldCollectCardProductClass',
  );

  if (shouldCollectCardProductClass) {
    return <CardProductClassRadioButtons />;
  }

  if (hasCardTypeSelector) {
    return <CardTypeSelector />;
  }

  return <CreditCardAndBankIconsBar />;
};

const SplitCardFields = () => {
  useMountLogging('SplitCardFields');
  const cardFieldsToDisplay = useStoreState(({ ui }) => ui.cardFieldsToDisplay);
  const isInstallmentButtonShown = useStoreState(
    ({ ui }) => ui.isInstallmentButtonShown,
  );
  const showConversion = useStoreState(
    ({ ui }) => ui.showCardConversionOptions,
  );

  return (
    <Fragment>
      <CardVendors />

      <CardNumber />

      <CardDetailsContainer>
        {cardFieldsToDisplay.expiry && <CardExpiry />}

        {cardFieldsToDisplay.cvv && <CardCvv />}

        {cardFieldsToDisplay.dob && <DateOfBirth />}
      </CardDetailsContainer>

      {showConversion && <CurrencyConversion />}
      {isInstallmentButtonShown && <InstallmentButton />}
    </Fragment>
  );
};

export { SplitCardFields };
